module.exports = __webpack_public_path__ + "static/media/superBg@4x.e08e6861.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/superBg@4x.png
// module id = 1860
// module chunks = 0 1